import React from 'react'

const BoltIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox='0 0 11 14'
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    {...props}
  >
    <path
      d='M2.66667 13.3333L3.33333 8.66667H0L6 0H7.33333L6.66667 5.33333H10.6667L4 13.3333H2.66667Z'
      fill='currentColor'
    />
  </svg>
)

export default BoltIcon
